import Store from "logic/local-storage/Store";
import { singleton } from "logic/singleton";
import createExternalStore from "logic/createExternalStore";
const USERNAME_KEY = "username";
const createSession = () => {
  const store = createExternalStore({ username: void 0 });
  const eventListeners = { logout: /* @__PURE__ */ new Set(), validated: /* @__PURE__ */ new Set() };
  const isLoggedIn = () => !!store.getState().username;
  const notify = (event) => eventListeners[event].forEach((listener) => {
    try {
      listener();
    } catch (error) {
      console.error(`Session '${event}' listener failed:`, error);
    }
  });
  const setUsername = (username) => {
    if (username) {
      Store.set(USERNAME_KEY, username);
    } else {
      Store.delete(USERNAME_KEY);
    }
    store.setState({ username });
  };
  const endSession = () => setUsername(void 0);
  let logoutHandler = async () => {
    endSession();
    notify("logout");
  };
  let pendingLogout;
  return {
    getState: store.getState,
    subscribe: store.subscribe,
    isLoggedIn,
    storedUsername: () => Store.get(USERNAME_KEY),
    setUsername,
    endSession,
    setLogoutHandler: (handler) => {
      logoutHandler = handler;
    },
    logout: () => {
      pendingLogout != null ? pendingLogout : pendingLogout = logoutHandler().finally(() => {
        pendingLogout = void 0;
      });
      return pendingLogout;
    },
    waitForLogin: () => isLoggedIn() ? Promise.resolve() : new Promise((resolve) => {
      const unsubscribe = store.subscribe(() => {
        if (isLoggedIn()) {
          unsubscribe();
          resolve();
        }
      });
    }),
    on: (event, listener) => {
      eventListeners[event].add(listener);
      return () => {
        eventListeners[event].delete(listener);
      };
    },
    notifyLogout: () => notify("logout"),
    notifyValidated: () => notify("validated")
  };
};
const Session = singleton("core.Session", createSession);
export default Session;
